import { DexpEndpointTierGroups } from '@hcs/types';
import { DATA_EXPLORER_URL } from '@hcs/urls';

import { DexpEndpointLevel, DexpSteps } from '../types';

export const DEXP_REPORTS_PER_PAGE = 20;
export const DEXP_WEB_SOCKET_URL = `${
  window.location.protocol === 'http:' ? 'ws:' : 'wss:'
}//${DATA_EXPLORER_URL.split('://', 2)[1]}/job-updates/`;

export const DEXP_ENDPOINT_LEVEL_LABEL: Record<DexpEndpointLevel, string> = {
  block: 'Block',
  blockgroup: 'Blockgroup',
  property: 'Property',
  metrodiv: 'Metrodiv',
  msa: 'MSA',
  state: 'State',
  value_report: 'Property Explorer',
  zip: 'ZIP Code',
  agile_insights: 'Agile Insights AVM',
};

export const ANALYSIS_RESULTS_URL_STATE_KEY = 'analysis-results-url-state';

export const DEXP_ENDPOINT_TIER_ORDER = [
  DexpEndpointTierGroups.Free,
  DexpEndpointTierGroups.Basic,
  DexpEndpointTierGroups.Premium,
  DexpEndpointTierGroups.PremiumPlus,
  DexpEndpointTierGroups.PropertyEstimate,
  DexpEndpointTierGroups.BuildToApi,
];
export const DATA_HC_EVENT_SECTION_PROPERTIES = 'Generate Analysis';
export const DATA_HC_EVENT_SECTION_ENDPOINTS = 'Select Data Points';
export const DEXP_INITIAL_STEP: DexpSteps = 'endpoints';

export const DEXP_MAX_ANALYSIS_ADDRESSES = 1000;

export const DEXP_ENDPOINTS_FILTER_IDS = {
  Search: 'search',
  Access: 'access',
  ExcludedEndpoints: 'excluded',
  IncludedEndpoints: 'included',
  Level: 'level',
} as const;
